import '../../../neb-material-design/src/components/neb-md-button';
import '../../../../src/components/misc/neb-icon';
import '../../../neb-lit-components/src/components/neb-button';

import { LitElement, html, css } from 'lit';

import { computeTime } from '../../../neb-input/nebFormatUtils';
import { baseStyles } from '../../../neb-styles/neb-styles';
import {
  CSS_FONT_WEIGHT_BOLD,
  CSS_COLOR_GREY_1,
  CSS_SPACING,
} from '../../../neb-styles/neb-variables';

export const ELEMENTS = {
  selectButton: { id: 'button' },
  name: { id: 'name' },
  duration: { id: 'duration' },
  description: { id: 'description' },
  disabledText: { id: 'disabled-text' },
  icon: { id: 'icon' },
};

class NebBookingServiceItem extends LitElement {
  static get properties() {
    return {
      item: Object,
      disabled: {
        type: Boolean,
        reflect: true,
      },
      layout: {
        type: String,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.item = {};
    this.disabled = false;
    this.layout = '';

    this.onServiceItemSelected = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      rowClick: () => {
        if (this.layout === 'small' && !this.disabled) {
          this.onServiceItemSelected(this.item);
        }
      },
      selectService: () => {
        this.onServiceItemSelected(this.item);
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.__handlers.rowClick);
  }

  static get styles() {
    return [
      baseStyles,
      css`
        :host {
          display: flex;
        }

        :host([layout='small']) .container {
          flex-direction: column;
        }

        :host([layout='small']) .detail {
          flex-direction: row;
        }

        :host([layout='small']) .description {
          font-size: 12px;
          flex: 0 1 auto;
        }

        :host([layout='small']) .duration {
          font-size: 12px;
          margin-left: 8px;
        }

        .container {
          flex: 1 0 0;
          display: flex;
          padding: 32.5px 25px;
        }

        .name {
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
        }

        .detail {
          flex: 1;
          min-width: 70px;
          display: flex;
          flex-direction: column;
        }

        .description {
          flex: 3;
          min-width: 190px;
        }

        .detail,
        .description {
          padding-right: 10px;
        }

        .disabled-service {
          padding-top: ${CSS_SPACING};
          font-style: italic;
          color: ${CSS_COLOR_GREY_1};
        }

        :host([disabled]) .name,
        :host([disabled]) .description,
        :host([disabled]) .duration {
          color: ${CSS_COLOR_GREY_1};
        }

        .container-button {
          flex: 1;
          text-align: right;
        }

        .container-icon {
          display: flex;
          align-items: center;
          padding: 32.5px 25px;
        }

        .icon {
          height: 12px;
          width: 12px;
          transform: rotate(-90deg);
          fill: ${CSS_COLOR_GREY_1};
        }
      `,
    ];
  }

  render() {
    return html`
      <div class="container">
        <div class="detail">
          <span id="${ELEMENTS.name.id}" class="name">${this.item.name}</span>
          <span id="${ELEMENTS.duration.id}" class="duration">
            (${computeTime(this.item.duration)})
          </span>
        </div>
        <div id="${ELEMENTS.description.id}" class="description">
          <span>${this.item.description}</span> ${this.disabled
            ? html`
                <div id="${ELEMENTS.disabledText.id}" class="disabled-service">
                  Service is available at other locations.
                </div>
              `
            : ''}
        </div>
        ${this.layout !== 'small'
          ? html`
              <div class="container-button">
                <neb-button
                  id="${ELEMENTS.selectButton.id}"
                  class="button"
                  label="Select"
                  .disabled="${this.disabled}"
                  .onClick="${this.__handlers.selectService}"
                ></neb-button>
              </div>
            `
          : ''}
      </div>

      ${this.layout === 'small'
        ? html`
            <div class="container-icon">
              <neb-icon
                id="${ELEMENTS.icon.id}"
                class="icon"
                icon="neb:chevron"
              ></neb-icon>
            </div>
          `
        : ''}
    `;
  }
}

customElements.define('neb-booking-service-item', NebBookingServiceItem);
